import { branch, renderNothing } from 'recompose'

import { AppStoreBadge, GooglePlayStoreBadge } from '../AppDownloadBadge'

import featureToggles from 'shared/featureToggles'
import { languageFromPath } from 'shared/country'
import BackgroundImageCanada_EN from 'shared/assets/app-canada.png'
import BackgroundImageCanada_FR from 'shared/assets/app-france.png'
import BackgroundImageBrazilNeo_EN from 'shared/assets/app-en-br-neo.png'
import BackgroundImageBrazilNeo_PT from 'shared/assets/app-pt-br-neo.png'

import './styles.scss'

const DownloadApp = () => {
    const getBackgroundImage = () => {
        if (featureToggles.brNeoPurchaseFlow) {
            if (languageFromPath() === 'en-ca') {
                return BackgroundImageBrazilNeo_EN
            }
            if (languageFromPath() === 'pt-br') {
                return BackgroundImageBrazilNeo_PT
            }
        } else {
            if (languageFromPath() === 'en-ca') {
                return BackgroundImageCanada_EN
            }
            return BackgroundImageCanada_FR
        }
    }
    return (
        <div className="download-app">
            <div className="download-app__bg">
                <div className="download-app__inner-container">
                    <div className="download-app__content">
                        <h2>
                            <T>download.app.today.title</T>
                        </h2>
                        <div className="download-app__logos">
                            <AppStoreBadge />
                            <GooglePlayStoreBadge />
                        </div>
                    </div>
                    <div className="download-app__phone">
                        <img src={getBackgroundImage()} alt="Indigo Neo app on phone background" />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default compose(branch(() => !featureToggles.showDownloadApp, renderNothing))(DownloadApp)
